import * as storeRegistry from "@api/store-registry";
import { apiWebV1Url } from "@services/urls";

import {
  fetchModelResources,
  findModelResource,
} from "@api/helpers/resource-helper";

const baseUrl = `${apiWebV1Url()}/countries`;

const config = {
  baseUrl,
  storeRegistry,
};

export async function fetchResources(params: Record<string, unknown>) {
  return fetchModelResources(config, params);
}

export async function findResource(id: string | number) {
  return findModelResource(config, id);
}
